var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c(
        "div",
        { staticClass: "max-w-sm mx-auto px-6" },
        [
          !_vm.timeslot
            ? _c("patient-loading")
            : _c(
                "div",
                { staticClass: "rounded bg-white shadow relative -mt-24" },
                [
                  !_vm.isBooked
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2",
                          attrs: {
                            to: {
                              path: "/search",
                              query: { type: _vm.timeslot.medicalPractice }
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-close" })
                          ])
                        ]
                      )
                    : _c(
                        "router-link",
                        {
                          staticClass:
                            "text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2",
                          attrs: { to: { path: "/" } }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-close" })
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _vm.isBooked
                    ? _c(
                        "div",
                        { staticClass: "p-6 bg-teal text-white rounded-t" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm",
                              on: {
                                click: function($event) {
                                  _vm.showPartnerMessage = !_vm.showPartnerMessage
                                }
                              }
                            },
                            [
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("Appointment_confirmed")))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-4 text-sm" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "You_have_booked_this_appointment_with_X_In_order_to_manage_it_you_will_be_redirecter_do_thier_website",
                                    { name: _vm.timeslot.partnerName }
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "p-6 bg-orange text-white rounded-t" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm",
                              on: {
                                click: function($event) {
                                  _vm.showPartnerMessage = !_vm.showPartnerMessage
                                }
                              }
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Appointment_provided_by_X", {
                                      name: _vm.timeslot.partnerName
                                    })
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-4 text-sm" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "This_appointment_is_provided_by_our_partner_X",
                                    { name: _vm.timeslot.partnerName }
                                  )
                                ) +
                                "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "Thus_you_will_be_redirected_to_their_website_in_order_to_book_it"
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-6" }, [
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "div",
                        { staticClass: "text-blue text-sm font-semibold mb-1" },
                        [_vm._v(_vm._s(_vm.$t("When_")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-black font-semibold text-lg" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("momentFormatTimestamp")(
                                _vm.timeslot.dateTime,
                                _vm.$t("date_selector_format") +
                                  " [" +
                                  _vm.$t("at") +
                                  "] " +
                                  _vm.$t("time_format")
                              )
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-4 flex justify-between" },
                      [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-blue text-sm font-semibold mb-1"
                            },
                            [_vm._v(_vm._s(_vm.$t("Who_will_treat_me_")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-grey-darkest" }, [
                            _vm._v(
                              _vm._s(
                                _vm.timeslot.doctorFirstName +
                                  " " +
                                  _vm.timeslot.doctorLastName
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.timeslot.isDoctorRegulated &&
                          (_vm.timeslot.medicalPractice !== "OSTEOPATH" &&
                            _vm.timeslot.medicalPractice !== "PSYCHOLOGIST")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-green font-semibold text-sm mt-1"
                                },
                                [_vm._v(_vm._s(_vm.$t("Regulated_Doctor")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.timeslot.isDoctorRegulated &&
                          (_vm.timeslot.medicalPractice !== "OSTEOPATH" &&
                            _vm.timeslot.medicalPractice !== "PSYCHOLOGIST")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-red font-semibold text-sm mt-1"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Contracted_doctor_negative"))
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("partner-avatar", {
                          staticClass: "ml-2 w-10 h-10",
                          attrs: { "external-url": _vm.timeslot.doctorAvatar }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c(
                        "div",
                        { staticClass: "text-blue text-sm font-semibold mb-1" },
                        [_vm._v(_vm._s(_vm.$t("Where_have_I_to_go_")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-grey-darkest" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.timeslot.officeStreetName)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.timeslot.officeZipCode) +
                            " " +
                            _vm._s(_vm.timeslot.officeLocality) +
                            "\n                        "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "gmap-map",
                    {
                      staticClass: "w-full",
                      staticStyle: { height: "250px" },
                      attrs: {
                        center: {
                          lat: _vm.timeslot.officeLatitude,
                          lng: _vm.timeslot.officeLongitude
                        },
                        zoom: 13,
                        options: { disableDefaultUI: true }
                      }
                    },
                    [
                      _c("gmap-marker", {
                        attrs: {
                          position: {
                            lat: _vm.timeslot.officeLatitude,
                            lng: _vm.timeslot.officeLongitude
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isBooked
                    ? _c("div", { staticClass: "px-6 py-4" }, [
                        _vm.userId
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "inline-block text-center bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                attrs: {
                                  href: _vm.timeslot.partnerUrl,
                                  target: "_blank"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.handleClick($event)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Book_this_appointment_with_X", {
                                      partner: _vm.timeslot.partnerName
                                    })
                                  )
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "bg-blue-light hover:bg-blue rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                on: { click: _vm.showLogin }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Sign_in_to_book_this_appointment")
                                  )
                                )
                              ]
                            )
                      ])
                    : _c("div", { staticClass: "px-6 py-4 rounded-b" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "inline-block text-center bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                            attrs: {
                              href: _vm.timeslot.partnerUrl,
                              target: "_blank"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.handleClick($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Manage_this_appointment_with_X", {
                                  partner: _vm.timeslot.partnerName
                                })
                              )
                            )
                          ]
                        )
                      ])
                ],
                1
              ),
          _vm._v(" "),
          _vm.timeslot
            ? _c("dfp-slot", {
                staticClass: "mt-6",
                attrs: {
                  path: "/21865209613/Patients/PartnerTimeslotShow",
                  size: [300, 250],
                  id: "div-gpt-ad-partner-timeslot",
                  "medical-practice": _vm.timeslot.medicalPractice
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f50ecb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f50ecb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/PartnerTimeslotShow.vue
// module id = 773
// module chunks = 1